module.exports = __webpack_public_path__ + "img/coupon-get-bf.b2bc2306.png";